const AdjustFloatingBox = (classID, margin) => {
  // on resize
  window.addEventListener('resize', event => {
    setBoxPosition(classID, margin);
  });

  // on load
  setBoxPosition(classID, margin);
}

function setBoxPosition(classID, margin = 0) {
  document.querySelectorAll(`.element-${classID}`).forEach(item => {
    const element = item.querySelector(`.element-${classID}__box`);

    if (element) {
      if (isMobileSize()) {
        const list = element.querySelector(`.element-${classID}__link-list`);
        if (list) {
          const rect = list.getBoundingClientRect(),
            bottom = rect.height - margin;
          element.style.bottom = `-${bottom}px`;
          item.style.marginBottom = `calc(1.5rem + ${bottom}px)`;
        }
      } else {
        element.style.bottom = '';
        item.style.marginBottom = '';
      }
    }
  })
}

function isMobileSize() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (width < 768) {
    return true;
  }

  return false;
}

export default AdjustFloatingBox;
